import { useTranslation } from 'react-i18next';
import devilExample from '../../assets/gallery-welcome/devil.webp';
import frameExample from '../../assets/gallery-welcome/frame.webp';
import basketballExample from '../../assets/gallery-welcome/basketball.webp';
import { Icon } from '../primitives';

const SAMPLE_IMAGES = [
  basketballExample,
  frameExample,
  devilExample,
];

export default function GalleryWelcomeState({ onStart }) {
  const { t } = useTranslation();

  return (
    <div
      className="flex h-full min-h-0 flex-col items-center justify-center overflow-hidden px-6 text-center"
      style={{
        paddingTop: 'calc(var(--safe-top, 0px) + 20px)',
        paddingBottom: 'calc(var(--safe-bottom, 0px) + 104px)',
      }}
      data-testid="gallery-welcome-state"
    >
      <div
        className="relative mb-7 h-[174px] w-[300px] max-w-full shrink-0"
        style={{ perspective: '800px' }}
        aria-hidden="true"
        data-testid="gallery-welcome-cards"
      >
        {SAMPLE_IMAGES.map((src, index) => {
          const offset = index - 1;
          const rotation = offset * 8;
          const translateX = offset * 72;
          const translateY = Math.abs(offset) * 14;
          const zIndex = 5 - Math.abs(offset);

          return (
            <div
              key={src}
              className={`anim-fan anim-fan-${index} absolute left-1/2 top-1/2 h-[166px] w-[120px] overflow-hidden rounded-[22px] border-[6px] border-white bg-surface-2 shadow-2xl`}
              style={{
                zIndex,
                '--fan-tx': `${translateX}px`,
                '--fan-ty': `${translateY}px`,
                '--fan-rot': `${rotation}deg`,
                '--fan-sc': '1',
                boxShadow: '0 12px 34px rgba(0,0,0,0.55)',
              }}
            >
              <img
                src={src}
                alt=""
                className="h-full w-full object-cover"
                loading="eager"
                draggable={false}
              />
            </div>
          );
        })}
      </div>

      <h1 className="mb-7 max-w-[330px] shrink-0 font-sans text-[30px] font-bold leading-[1.18] text-text-primary">
        {t('gallery.emptyTitleLine1')}
        <br />
        {t('gallery.emptyTitleLine2')}
      </h1>

      <button
        type="button"
        onClick={onStart}
        className="flex h-16 min-w-[252px] shrink-0 items-center justify-center gap-3 rounded-full bg-[#2F2F31] px-8 font-sans text-[18px] font-bold text-text-primary transition-transform active:scale-[0.97]"
        data-testid="gallery-welcome-cta"
      >
        <span>{t('gallery.emptyStartCreating')}</span>
        <Icon name="ai-filters" size={24} className="text-text-primary" />
      </button>
    </div>
  );
}
